module.exports = __webpack_public_path__ + "img/icbc.c2677626.png";